import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import CardWrap from '../../microservice/components/CardWrapper';
// import config from '../components/config';
import Sidebar from '../../container/Sidebar/Sidebar';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-en';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import HeaderEn from '../../detailpageVN/Page/component/headeren';
import SidebarEn from '../../container/Sidebar/Sidebar-en';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;
// Titlecloudcompute
function WebHookENG() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Webhook - Serverless Application - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudVN />
            <Container className='main-body'>
                <Row>
                    <Col lg={3} md={12} xs={12}>
                        {!isMobile && <SidebarEn />}
                    </Col>
                    <Col lg={9} md={12} xs={12} className="right-content">
                        {/* {Titlecloudcompute("Webhook")} */}
                        <BoxContent>
                            <BoxText  ><p class="typo-14">• Webhooks are event notifications sent directly to a user-selected URL.</p></BoxText>
                            <BoxText  ><p class="typo-14">• Users trigger events on one site, which then invoke programs on other sites.</p></BoxText>
                            <BoxText  ><p class="typo-14">• In a microservices environment, webhooks simplify the orchestration of related tasks across small applications or external systems, significantly reducing development time.</p></BoxText>
                            {/* {Imagecloudcompute("https://hanbiro.com/cloud/library2/webhook/webhook-1.svg")} */}
                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/webhook-1.png"></ImageWrap>
                            <BoxText ><p class="typo-14">When a specific external event occurs, it triggers a call to the client (Reverse API).</p></BoxText>
                            <BoxText ><p class="typo-14">The URL that the client is called from or to which data is sent is known as the Callback URL.</p></BoxText>
                            <BoxText ><p class="typo-14">Hooking means adding additional actions before or after a specific operation.</p></BoxText>
                        </BoxContent>
                        <DividerComponent />
                        {/*
                        {CardWrap("• 가격",config.tb6_header,config.tb6_content)}
                        */}
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">Webhook on AWS</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/cloud/library2/webhook/webhook-2.svg"></ImageWrap>
                        </BoxContent>


                        {/* {CardWrap(
                            "<p>• AWS 의 Webhook</p>",
                            "", 
                            "", 
                            "https://hanbiro.com/cloud/library2/webhook/webhook-2.svg"
                        )} */}

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            <FooterEn />
        </Sysfont>
    );
};

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px; 
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default WebHookENG;